import TextInput from "components/TextInput";
import React, { useEffect, useState } from "react";
import { Button, Col, Container, Row ,Spinner} from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { resetPasswordSchema } from "validations/authSchema";
import { resetPassword, verifyResetToken } from "api/authService";
import Loader from "components/Loader";

const ResetPassword = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [tokenStatus, setTokenStatus] = useState("loading");

  useEffect(() => {
    const checkToken = async () => {
      const queryParams = new URLSearchParams(location.search);
      const token = queryParams.get("token");

      if (!token) {
        setTokenStatus("invalid");
        return;
      }

      try {
        const res = await verifyResetToken(token)
        console.log(res,"res");
        if (res.success) {
          setTokenStatus("valid");
        } else {
          setTokenStatus("invalid");
        }
      } catch (err) {
        setTokenStatus("invalid");
      }
    };

    checkToken();
  }, [location.search]);

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors, isSubmitting },
  } = useForm({
    resolver: yupResolver(resetPasswordSchema),
  });

  console.log('tokenStatus', tokenStatus)
  const onResetSubmit = async (data) => {
    try {
      const queryParams = new URLSearchParams(location.search);
      const token = queryParams.get("token");
      if (!token) {
        toast.error("Reset token not found");
        return;
      }
      const payload = {
        token: token,
        password: data.password,
      };
      const res = await resetPassword(payload);
      if (res.success === true && res.code === 200) {
        toast.success(res.message);
        reset();
        navigate("/");
      } else {
        toast.error(res.message);
      }
    } catch (err) {
      toast.error(err.message || "Reset password failed");
    }
  };

  if(tokenStatus === "loading"){
    return (
      <div className="loaderdiv">
        {/* <Sentry color="#e91515" size={40} speed={1} animating={true} /> */}
        <Loader />
      </div>
    )
   }
  return (
    <section
      className="py-5"
      style={{
        height: "calc(76vh)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Container>
        <Row>
          <Col lg={12}>
            {tokenStatus === "invalid" ? (
              <div className="reset_password_height">
                <div className="text-center">
                  <h3 className="text-danger">Link Expired or Invalid</h3>
                  <p>Please request a new reset link.</p>
                </div>
              </div>
            ) : (
              <form onSubmit={handleSubmit(onResetSubmit)}>
                <div className="passCard">
                  <h2 className="text-center">Reset Password</h2>
                  <TextInput
                    labelText={"Password"}
                    type="password"
                    placeholder={"Enter Password"}
                    {...register("password")}
                    errorMessage={errors.password?.message}
                  />
                  <TextInput
                    labelText={"Confirm Password"}
                    type="password"
                    placeholder={"Enter Confirm Password"}
                    {...register("confirmPassword")}
                    errorMessage={errors.confirmPassword?.message}
                  />
                  <Button
                    variant="info"
                    className="w-100 border-radius-100 d-flex justify-content-center align-items-center"
                    type="submit"
                    disabled={isSubmitting}
                  >
                    {isSubmitting ? <Spinner animation="border" size="sm" /> : "Continue"}
                  </Button>
                </div>
              </form>
            )}
          </Col>
        </Row>
      </Container>
    </section>
  );
};
export default ResetPassword;
